import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, Typography
} from '@mui/material';
import { useTranslation } from 'react-i18next';

type Props = {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
};

export default function ClearAllConfirmModal(props: Props) {
    const { t } = useTranslation('whiteboard');
    const { t: tCommon } = useTranslation('common');
    const { t: tWhiteboard } = useTranslation('whiteboard');

    return (
        <Dialog
            open={props.open}
            maxWidth="sm"
            fullWidth={true}
            onClose={props.onClose}
        >
            <DialogTitle>{t('clearAllTitle')}</DialogTitle>
            <DialogContent>
                <Typography>{t('clearAllConfirm')}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} variant="outlined" color="primary">
                    {tCommon('cancel')}
                </Button>
                <Button onClick={props.onConfirm} variant="contained" color="error">
                    {tWhiteboard('clearAll')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
